<div class="BarcodeContainPage-content">
  <div class="upload-col">
    <show-need-top-up *ngIf="showNeedTopUp"></show-need-top-up>
    <div *ngIf="!showNeedTopUp" draggable="true" ngClass="{{dragAreaClass}}" (click)="file.click()">
      <div>
        <div class=" text-center">
          <div *ngIf="!draggedFiles" class="dragareaContain">
            {{"Drag an Image/PDF file containing a document here\." | i18n}}
          </div>
          <!-- <a class="chooseImgLink" href="javascript:void(0)" *ngIf="!draggedFiles">
            או בחר תמונה
          </a>
          <a class="chooseImgLinkMobile" href="javascript:void(0)" *ngIf="!draggedFiles">
            בחר תמונה
          </a> -->
          <input type="file" #file [multiple]="false" (change)="onFileChange($event)" style="display:none" />
          <div class="dragged-files-wrapper" *ngIf="draggedFiles">
            <div class="file" *ngFor="let file of draggedFiles">
              {{file.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error" *ngIf="error">
      Only one file at time allow
    </div>
    <app-barcode-table #barcodeTable></app-barcode-table>

  </div>
  <div class="canvas-col canvasCompContain barcodeCanvasColumn" #canvasCompContain
    [style.maxHeight.px]="windowHeight-100">

    <app-canvas-comp #canvasComp [imageURL]="imageURL" [fileName]="fileName">
      <!-- *ngIf="imageURL && imageURL !== ''" -->
    </app-canvas-comp>
  </div>
</div>
<div id="loader" *ngIf="loadingFlag"></div>